
import React from "react";
import { useIsMobile } from "@/hooks/use-mobile";

const ScriptureTransitionSection = () => {
  const isMobile = useIsMobile();
  
  return (
    <div className={`relative w-full overflow-hidden ${isMobile ? 'min-h-[300px]' : 'min-h-[350px]'} my-0 py-0`}>
      <div className="absolute inset-0 w-full h-full z-0">
        <img 
          src="https://bbhhusjprzalcwvkgvsa.supabase.co/storage/v1/object/public/photos//hands%20banner.png" 
          alt="Praying hands" 
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-[#34495E]/70"></div>
      </div>
      
      <div className="absolute inset-0 flex items-center justify-center z-20 px-6">
        <div className="max-w-3xl text-center">
          <div>
            <h3 className={`font-playfair ${isMobile ? 'text-2xl' : 'text-3xl md:text-4xl'} text-white font-semibold mb-4 drop-shadow-lg shadow-black`}>
              "Your word is a lamp to my feet and a light to my path."
            </h3>
            <p className="text-white/80 text-lg md:text-xl font-medium drop-shadow-md">— Psalm 119:105</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScriptureTransitionSection;
